module.exports = __webpack_public_path__ + "static/media/dog_sad.2dc8a594.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dog_sad.svg
// module id = 264
// module chunks = 0